import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import UIAssetKeys from '../UIAssetKeys';

export default class Emitter extends Phaser.GameObjects.Container {
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, size) {
        super(scene);

        this.size = size;
        this.time = Date.now();;
        this.particleCount = 0;
        this.stopEmitter = false;
        this.exploded = false;
    }

    emitParticles(emitterHandler, numParticles) {
        this.numParticles = numParticles;
        switch (emitterHandler) {
            case "bubbles":
                this.scene.events.on(Phaser.Scenes.Events.PRE_UPDATE, this.bubbles, this);
                this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.bubbles, this));
                break;
            default:
                this.exploded = false;
                this.scene.events.on(Phaser.Scenes.Events.PRE_UPDATE, this.explodeBubble, this);
                this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.explodeBubble, this));
        }
    }

    bubbles() {
        if (this.stopEmitter) {
            this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.bubbles, this);
        }

        let now = Date.now();
        let elapsed = now - this.time;
        this.time = now;

        if (!this.doneBubbles) {
            for (let i = 0; i < 100; i++) {
                this.createBubble();
                this.doneBubbles = true;
            }
        }

        for (let i = 0; i < this.length; i++) {
            let circle = this.getAt(i);
            circle.time += elapsed / 1000;
            circle.x += Phaser.Math.Between(0, 6) - 3;
            circle.y += circle.speedY;

            if (circle.y < -700) {
                circle.destroy();
            }
        }
    }

    createBubble() {
        let sprite = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._tiny_bubble, this).setOrigin(0);

        sprite.x = Math.random() * this.scene.scale.width;
        sprite.y = 0;
        sprite.speedX = 0;
        sprite.speedY = -5 * (1 + Math.random());
        sprite.time = 1;
        sprite.alpha = 1;
        sprite.scale = 1 + (0.5 - Math.random());
    }

    explodeBubble() {
        let now = Date.now();
        let elapsed = now - this.time;
        this.time = now;

        if (!this.exploded) {
            this.createSprite2("bubble_fragment");
            this.createSprite2("bubble_fragment");
            this.createSprite2("bubble_fragment");
            this.createSprite2("bubble_fragment");
            this.createSprite2("bubble_fragment");
            this.createSprite2("bubble_fragment");
            this.createSprite2("bubble_fragment");
            this.createSprite2("bubble_fragment");
            this.createSprite2("bubble_fragment");
            this.createSprite2("bubble_fragment");
            this.createSprite2("bubble_fragment");
            this.createSprite2("bubble_fragment");
            this.particleCount++;

            this.exploded = true;
        }

        for (let i = 0; i < this.length; i++) {
            let circle = this.getAt(i);

            circle.time += elapsed / 1000;
            circle.x += circle.speedX;
            circle.y += circle.speedY;

            if (circle.y > this.scene.scale.height + this.size || circle.time > 0.15) {
                circle.destroy();

                if (this.length == 0) {
                    this.removeAllListeners();
                    this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.explodeBubble, this);
                }
                i--;
            }
        }
    }

    createSprite2(name) {
        let sprite = ABCyaPhaser.Images.addImage(0, 0, name, this);

        sprite.x = sprite.x + Math.random() * 100;
        sprite.y = sprite.y;

        sprite.speedX = 25 - (50 * Math.random());
        sprite.speedY = 25 - (50 * Math.random());
        sprite.time = 0;
        sprite.angle = 360 * Math.random();
        sprite.scale = 0.5 + Math.random();
    }
}